import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import {
  Badge,
  Button,
  Col,
  Dropdown,
  Grid,
  Layout,
  Menu,
  Row,
  Select,
  Space,
  Tag,
} from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import global from 'src/shared/assets/svg/icon/global.svg';
import userSvg from 'src/shared/assets/svg/icon/user.svg';
import Logo from 'src/shared/assets/svg/logo.svg';
import {
  AffixC,
  AlertC,
  ButtonC,
  FlagC,
  IconC,
  LoadingC,
  SelectC,
} from 'src/shared/components';
import fileDownloader from 'src/shared/function/fileDownloader';
import unFlatten from 'src/shared/function/unFlatten';
import useAuth from 'src/shared/hooks/useAuth';
import useDirection from 'src/shared/hooks/useDirection';
import useDomain from 'src/shared/hooks/useDomain';
import useLocalization from 'src/shared/hooks/useLocalization';
import RoleEnum from 'src/shared/ts/enum/role.enum';
import useSWR from 'swr';
import NotificationsHeader from '../Notifications/NotificationsHeader';
import './layout.Panel.Component.less';
const { Header, Sider, Content } = Layout;
const LayoutPanelComponent = ({ children, domainData }: any) => {
  const { isLogedIn, decode, logout, hasPermission, hasRole } = useAuth();
  const { useBreakpoint } = Grid;
  const { lg, md, sm, xs, xxl } = useBreakpoint();
  const [state, setState] = useState({ collapsed: false });
  const { data: languages } = useSWR(`/localization/languages`);
  const { data: menuData } = useSWR(`/menu/select`);
  const { getLanguage, setLanguage, setCurrency, getCurrency } =
    useLocalization();
  const { symbol_native } = useDomain();
  const { data: checkpayment, isValidating: isValidatingCheckpayment } = useSWR(
    hasRole(RoleEnum.bookero_user) ? `/auth/bookero/checkpayment` : null
  );

  const isEndUser = hasRole(RoleEnum.end_user);
  const { data: endUsertotalPurshes, isValidating } = useSWR(
    isEndUser ? `/product-order/user/totalPurshes` : null
  );
  const {
    location: { pathname },
    push,
  } = useHistory();
  const toggle = () => {
    setState({
      collapsed: !state.collapsed,
    });
  };
  const { i18n, t } = useTranslation();
  const { isRtl, styler } = useDirection();
  // Flags;
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // localStorage.setItem("lng", lng);
  };

  const menuLng = (
    <Menu
      style={{ maxHeight: '300px', overflowY: 'auto' }}
      className='menu-languages'
    >
      {(languages || [])?.map((item: any) => (
        <Menu.Item
          key={item.language}
          onClick={() => changeLanguage(item.language)}
          icon={
            <FlagC
              type={
                item.language.split('-')[item.language.split('-').length - 1]
              }
            />
          }
        >
          {item.language}
        </Menu.Item>
      ))}
    </Menu>
  );

  if (hasRole(RoleEnum.bookero_user) && isValidatingCheckpayment)
    return <LoadingC />;

  function ListItem({ item }: any) {
    if (item.children) {
      return item.children.map((item: any) =>
        item.children && item.children.length ? (
          <SubMenu
            className='UnselectedItem'
            key={item.id}
            title={t(item.title)}
          >
            {ListItem({ item })}
          </SubMenu>
        ) : (
          <Menu.Item
            className='UnselectedItem'
            key={item.id}
            title={t(item.title)}
          >
            <Link to={item.route}>{t(item.title)}</Link>
          </Menu.Item>
        )
      );
    }
  }

  const HeaderResponsive = () => {
    if (!md) {
      return (
        <>
          <div>
            {/* {isEndUser ? (
              <Link to="/panel/buyProduct">
                <ButtonC size="small" type="primary">سفارش جدید +</ButtonC>
              </Link>
            ) : null} */}{' '}
            {isEndUser ? (
              <Link to='/panel/loyalityLevel'>
                <ButtonC size='small' type='dashed'>
                  سطح کاربری : {endUsertotalPurshes?.pervName}
                </ButtonC>
              </Link>
            ) : null}
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu>
                  {(function () {
                    if (
                      hasPermission([
                        {
                          route: '/auth/bookero/completeprofile',
                          method: 'PATCH',
                        },
                      ])
                    ) {
                      return (
                        <Menu.Item
                          icon={
                            <IconC
                              type='ProfileOutlined'
                              style={{
                                fontSize: '17px',
                                color: '#939393',
                              }}
                            />
                          }
                        >
                          <Link to='/panel/profile/bookero'>
                            {t('profile')}
                          </Link>
                        </Menu.Item>
                      );
                    } else if (
                      hasPermission([
                        {
                          route: '/auth/user/completeprofile',
                          method: 'PATCH',
                        },
                      ])
                    ) {
                      return (
                        <Menu.Item
                          icon={
                            <IconC
                              type='ProfileOutlined'
                              style={{
                                fontSize: '17px',
                                color: '#939393',
                              }}
                            />
                          }
                        >
                          <Link to='/panel/profile/tagrani'>
                            {t('profile')}
                          </Link>
                        </Menu.Item>
                      );
                    }
                  })()}
                  <Menu.Item>
                    <NotificationsHeader />
                  </Menu.Item>
                  {/* {isEndUser ? (
                    <Menu.Item>
                      <ButtonC type="link" href="/panel/buyProduct">
                        سفارش جدید +
                      </ButtonC>
                    </Menu.Item>
                  ) : null} */}

                  <SubMenu
                    icon={
                      <img
                        src={global}
                        style={{ ...styler({ marginLeft: '1px' }) }}
                      />
                    }
                    // title={localStorage.getItem("lng") as string}
                    title={
                      // @ts-ignore
                      JSON.parse(localStorage.getItem('localization'))
                        ?.languageKey as string
                    }
                  >
                    <SelectC
                      showSearch
                      size='small'
                      style={{
                        width: '120px',
                        transform: 'translate(0,12px)',
                        color: '#fff',
                      }}
                      bordered={false}
                      // col={{ xs: 24 }}
                      defaultValue={
                        getLanguage()?.language ||
                        // @ts-ignore
                        JSON.parse(localStorage.getItem('localization'))
                          ?.language
                      }
                      api='/localization/languages/select'
                      formItem={{
                        label: '',
                        name: 'language',
                      }}
                      onChange={(e, r) => {
                        //@ts-ignore
                        setLanguage(e, r?.row?.iso639_1, r?.row?.isRtl);
                        window.location.reload();
                      }}
                    />
                  </SubMenu>
                  <Menu.Item
                    icon={
                      <IconC
                        type='LogoutOutlined'
                        style={{ fontSize: '17px' }}
                      />
                    }
                    onClick={logout}
                  >
                    {t('logout')}
                  </Menu.Item>
                </Menu>
              }
              placement='bottomCenter'
            >
              <Button type='text' onClick={(e) => e.preventDefault()}>
                <img
                  src={userSvg}
                  style={{ ...styler({ marginLeft: '7px' }) }}
                />
                <span>
                  {decode?.firstName} {decode?.lastName}
                </span>
              </Button>
            </Dropdown>
          </div>
        </>
      );
    } else {
      return (
        <Space direction='horizontal' size={30}>
          {isEndUser ? (
            <span>
              <Link to='/panel/buyProduct'>
                <ButtonC type='primary'>سفارش جدید +</ButtonC>
              </Link>
            </span>
          ) : null}
          {isEndUser ? (
            <Link to='/panel/loyalityLevel'>
              <ButtonC size='large' type='dashed'>
                سطح کاربری : {endUsertotalPurshes?.pervName}
              </ButtonC>
            </Link>
          ) : null}
          <NotificationsHeader />
          <div>
            <Dropdown
              trigger={['click', 'hover']}
              overlay={
                <Menu>
                  {(function () {
                    if (
                      hasPermission([
                        {
                          route: '/auth/bookero/completeprofile',
                          method: 'PATCH',
                        },
                      ])
                    ) {
                      return (
                        <Menu.Item
                          icon={
                            <IconC
                              type='ProfileOutlined'
                              style={{
                                fontSize: '17px',
                                color: '#939393',
                              }}
                            />
                          }
                        >
                          <Link to='/panel/profile/bookero'>
                            {t('profile')}
                          </Link>
                        </Menu.Item>
                      );
                    } else if (
                      hasPermission([
                        {
                          route: '/auth/user/completeprofile',
                          method: 'PATCH',
                        },
                      ])
                    ) {
                      return (
                        <Menu.Item
                          icon={
                            <IconC
                              type='ProfileOutlined'
                              style={{
                                fontSize: '17px',
                                color: '#939393',
                              }}
                            />
                          }
                        >
                          <Link to='/panel/profile/tagrani'>
                            {t('profile')}
                          </Link>
                        </Menu.Item>
                      );
                    }
                  })()}
                  <Menu.Item
                    icon={
                      <IconC
                        type='LogoutOutlined'
                        style={{ fontSize: '17px' }}
                      />
                    }
                    onClick={logout}
                  >
                    {t('logout')}
                  </Menu.Item>
                </Menu>
              }
              placement='bottomCenter'
            >
              <Button type='text'>
                <img
                  src={userSvg}
                  style={{ ...styler({ marginLeft: '7px' }) }}
                />
                <span>
                  {decode?.firstName} {decode?.lastName}
                </span>
              </Button>
            </Dropdown>
          </div>
          <div>
            {/* <span>
              <img src={global} style={{ ...styler({ marginLeft: "1px" }) }} />
            </span> */}
            <SelectC
              // showSearch
              size='small'
              style={{ width: '120px', transform: 'translate(0,10px)' }}
              dropdownStyle={{ verticalAlign: '-5px' }}
              bordered={false}
              // col={{ xs: 24 }}
              defaultValue={
                getLanguage()?.language ||
                // @ts-ignore
                JSON.parse(localStorage.getItem('localization'))?.language
              }
              api='/localization/languages/select'
              formItem={{
                label: '',
                name: 'language',
              }}
              onChange={(e, r) => {
                //@ts-ignore
                setLanguage(e, r?.row?.iso639_1, r?.row?.isRtl);
                window.location.reload();
              }}
            />
            {/* <Select
              style={{ width: "120px" }}
              bordered={false}
              onChange={changeLanguage}
              // defaultValue={localStorage.getItem("lng") as string}
              defaultValue={
                // @ts-ignore
                JSON.parse(localStorage.getItem("localization"))
                  ?.languageKey as string
              }
            >
              {languages?.map((item: any) => (
                <Select.Option value={item.language} key={item.language}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <FlagC
                        style={{ verticalAlign: "-5px" }}
                        type={
                          item.language.split("-")[
                            item.language.split("-").length - 1
                          ]
                        }
                      />
                    </div>
                    <div>{item.language}</div>
                  </div>
                </Select.Option>
              ))}
            </Select> */}
          </div>

          <div>
            {(hasRole(RoleEnum.end_user) || hasRole(RoleEnum.tagrani_user)) && (
              <SelectC
                // showSearch
                size='small'
                style={{ width: '120px', transform: 'translate(0,10px)' }}
                dropdownStyle={{ verticalAlign: '-5px' }}
                bordered={false}
                // col={{ xs: 24 }}
                defaultValue={getCurrency()?.currencyId}
                api='/localization/currency/select'
                formItem={{
                  label: '',
                  name: 'currency',
                }}
                onChange={(e, r) => {
                  //@ts-ignore
                  setCurrency(e, r?.row?.symbol_native);
                  window.location.reload();
                }}
              />
            )}
          </div>
        </Space>
      );
    }
  };
  return (
    <div className='LayoutComponent'>
      {!state.collapsed && xs && (
        <div
          onClick={() => xs && setState({ collapsed: true })}
          style={{
            position: 'absolute',
            width: '100vw',
            height: '100vh',
            right: 0,
            left: 0,
            top: '64px',
            bottom: 0,
            background: 'rgba(0,0,0,0.7)',
            zIndex: 1,
          }}
        />
      )}
      <Layout>
        <Sider
          trigger={
            xs &&
            React.createElement(
              state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: 'trigger',

                onClick: toggle,
                style: {
                  position: 'absolute',
                  fontSize: '20px',
                  ...styler({ marginRight: '25px' }),
                  right: 180,
                  top: -41,
                },
              }
            )
          }
          style={{
            ...styler({ right: 0 }),
            overflowY: 'auto',
            height: '100vh',
            position: 'fixed',
            overflowX: 'hidden',
            background: '#363740',
            zIndex: isEndUser ? 9999 : 'initial',
          }}
          collapsed={state.collapsed}
          collapsible
          collapsedWidth='0'
          breakpoint='lg'
          onBreakpoint={(broken) => {
            setState({ collapsed: broken });
          }}
        >
          {React.createElement(
            state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: 'trigger',

              onClick: toggle,
              style: {
                position: 'absolute',
                fontSize: '20px',
                ...styler({ marginRight: '25px' }),
                right: 200,
              },
            }
          )}
          <div>
            <div style={{ textAlign: 'center', margin: '7px 0 20px 0' }}>
              <img
                src={
                  domainData?.logoPath && fileDownloader(domainData?.logoPath)
                }
                style={{ width: '65%', cursor: 'pointer' }}
                onClick={() =>
                  isEndUser ? push('/panel/buyProduct') : push('/panel')
                }
              />
            </div>

            <Menu
              // disabled={!decode?.profileComplated}
              theme='dark'
              mode='inline'
              defaultSelectedKeys={[pathname?.split('panel')[0]]}
              style={{ background: '#363740' }}
            >
              {unFlatten(menuData)?.map((item: any) =>
                item.children && item.children.length ? (
                  <Menu.SubMenu
                    className='UnselectedItem'
                    key={item.id}
                    title={t(item.title)}
                  >
                    {ListItem({ item })}
                  </Menu.SubMenu>
                ) : (
                  <Menu.Item
                    key={item.id}
                    title={t(item.title)}
                    onClick={() => xs && setState({ collapsed: true })}
                  >
                    {item.route.includes('automationOrder') ? (
                      <>
                        <Link to={item.route}>{t(item.title)}</Link>
                        <Tag className='new-label'>جدید</Tag>
                      </>
                    ) : (
                      <Link to={item.route}>{t(item.title)}</Link>
                    )}
                  </Menu.Item>
                )
              )}
            </Menu>
          </div>
        </Sider>
        <Layout
          className='site-layout'
          style={{
            ...styler({
              marginRight: (isEndUser && xs) || state.collapsed ? 0 : 200,
            }),
          }}
        >
          <AffixC>
            <Header
              className='site-layout-background'
              style={{
                padding: 0,
                display: 'flex',
                alignItems: 'center',
                zIndex: 5,
              }}
            >
              {React.createElement(
                state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                {
                  className: 'trigger',
                  onClick: toggle,
                  style: {
                    fontSize: '20px',
                    ...styler({ marginRight: '25px' }),
                  },
                }
              )}
              <div
                style={{
                  ...styler({
                    textAlign: 'left',
                    paddingLeft: '35px',
                    width: '100%',
                  }),
                }}
              >
                <HeaderResponsive />
              </div>
            </Header>
          </AffixC>
          <Content
            style={{ overflow: 'initial' }}
            onClick={() => xs && setState({ collapsed: true })}
          >
            <div style={{ padding: !md ? 10 : 24, minHeight: '87vh' }}>
              {(function () {
                if (
                  hasRole(RoleEnum.bookero_user) &&
                  (!checkpayment?.expireDate ||
                    new Date(checkpayment?.expireDate).getTime() < Date.now())
                ) {
                  return (
                    <AlertC
                      message={
                        <div>
                          <ButtonC
                            type='text'
                            danger
                            size='small'
                            onClick={() =>
                              push('/panel/whitelabel/representation')
                            }
                          >
                            {t('click to complete the agency information')}
                          </ButtonC>
                        </div>
                      }
                      type='warning'
                    />
                  );
                } else if (
                  hasRole(RoleEnum.tagrani_user) &&
                  !decode?.profileComplated
                ) {
                  return (
                    <AlertC
                      message={
                        <div>
                          {t('to continue, please complete your profile')}
                          <ButtonC
                            type='text'
                            danger
                            size='small'
                            onClick={() => push('/panel/profile/tagrani')}
                          >
                            {t('complete the profile')}
                          </ButtonC>
                        </div>
                      }
                      type='warning'
                    />
                  );
                }

                // if (origin.includes("followjet")) {
                //   return (
                //     <AlertC
                //       message={
                //         <div>
                //           {t(
                //             "در صورت نیاز به مشاهده تاریخچه سفارشات تان به داشبورد قدیمی مراجعه کنید"
                //           )}
                //           <ButtonC
                //             type="text"
                //             danger
                //             size="small"
                //             onClick={() =>
                //               window.location.replace(
                //                 "https://app.followjet.com"
                //               )
                //             }
                //           >
                //             {t("رفتن به پنل قدیمی")}
                //           </ButtonC>
                //         </div>
                //       }
                //       type="warning"
                //     />
                //   );
                // }
                // if (origin.includes("followcamp")) {
                //   return (
                //     <AlertC
                //       message={
                //         <>
                //           <div>
                //             {t(
                //               "در صورت نیاز به مشاهده تاریخچه سفارشات تان به داشبورد قدیمی مراجعه کنید"
                //             )}
                //             <ButtonC
                //               type="text"
                //               // danger
                //               size="small"
                //               onClick={() =>
                //                 window.location.replace(
                //                   "https://app.followcamp.com"
                //                 )
                //               }
                //             >
                //               {t("رفتن به پنل قدیمی ۱")}
                //             </ButtonC>
                //           </div>
                //           <div>
                //             {t(
                //               "در صورت نیاز به مشاهده تاریخچه سفارشات تان به داشبورد قدیمی مراجعه کنید"
                //             )}
                //             <ButtonC
                //               type="text"
                //               // danger
                //               size="small"
                //               onClick={() =>
                //                 window.location.replace(
                //                   "https://followcamp.com/my-account/orders"
                //                 )
                //               }
                //             >
                //               {t("رفتن به پنل قدیمی ۲")}
                //             </ButtonC>
                //           </div>
                //         </>
                //       }
                //       type="warning"
                //     />
                //   );
                // }
              })()}
              {/* {isEndUser ? (
                <Row justify="space-between">
                  <Col
                    style={{ fontWeight: "bold", textAlign: "justify" }}
                    xs={24}
                    lg={11}
                  >
                    موقتا به دلیل مشکلات در درگاه های پرداخت آنلاین، سفارشات خود
                    را از طریق واتس اپ و کارت به کارت ثبت کنید
                  </Col>
                  <Col xs={24} lg={11}>
                    <a target="_blank" href="https://api.whatsapp.com/send/?text=%D8%B3%D9%84%D8%A7%D9%85%20%D9%88%D9%82%D8%AA%20%D8%A8%D8%AE%DB%8C%D8%B1&phone=989120463342">
                      <ButtonC block>سفارش با واتس اپ</ButtonC>
                    </a>
                  </Col>
                </Row>
              ) : null} */}
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default LayoutPanelComponent;
